"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var FlexBanner = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
    _a = props.buttonList,
    buttonList = _a === void 0 ? [] : _a,
    insights = props.insights,
    tabShow = props.tabShow,
    tabList = props.tabList,
    backgroundUrl = props.backgroundUrl,
    backgroundUrlLogo = props.backgroundUrlLogo,
    restProps = __rest(props, ["className", "buttonList", "insights", "tabShow", "tabList", "backgroundUrl", "backgroundUrlLogo"]);
  var formatBackgroundUrl = (0, _utils.fomateFileData)(backgroundUrl).url;
  var formatBackgroundUrlLogo = (0, _utils.fomateFileData)(backgroundUrlLogo).url;
  var compatibleArr = buttonList;
  if (buttonList.length < 3) {
    compatibleArr = buttonList && buttonList.length % 3 ? __spreadArrays(buttonList, new Array(3 - buttonList.length % 3).fill({
      supplement: true
    })) : buttonList;
  }
  var useRefLi = (0, _react.useRef)(null);
  // banner logo img
  var imgRefsImage = (0, _react.useRef)(null);
  // 内容区域
  var insightsRef = (0, _react.useRef)(null);
  var play = false;
  var i = 0;
  var currentLi = 0;
  var time = 260;
  var listMap = formatBackgroundUrlLogo;
  var listMapLen = (0, _typeof2["default"])(formatBackgroundUrlLogo) === 'object' && listMap.length;
  var changeLibg = function changeLibg(i) {
    if (useRefLi.current) {
      // @ts-ignore
      useRefLi.current.childNodes[currentLi % listMapLen].childNodes[0].style.transform = "scale(" + 40 / 40 / time * (i || 0) + ",1)";
    }
  };
  var _conLog = function conLog() {
    if (play) return;
    i++;
    if (i % time === 0) {
      i = 0;
      currentLi += 1;
      if (useRefLi.current && imgRefsImage.current) {
        // @ts-ignore
        imgRefsImage.current.childNodes[currentLi % listMapLen].style.opacity = 1;
        // @ts-ignore
        imgRefsImage.current.childNodes[currentLi % listMapLen > 0 ? currentLi % listMapLen - 1 : listMapLen - 1].style.opacity = 0;
        // @ts-ignore
        insightsRef.current.childNodes[currentLi % listMapLen].style.opacity = 1;
        // @ts-ignore
        insightsRef.current.childNodes[currentLi % listMapLen > 0 ? currentLi % listMapLen - 1 : listMapLen - 1].style.opacity = 0;
        // @ts-ignore
        useRefLi.current.childNodes[currentLi % listMapLen > 0 ? currentLi % listMapLen - 1 : listMapLen - 1].childNodes[0].style.transform = "scale(0,1)";
      }
    }
    changeLibg(i);
    requestAnimationFrame(_conLog);
  };
  (0, _react.useEffect)(function () {
    // changeLibg();
    if (listMapLen > 1) {
      _conLog();
    }
  }, []);
  var contentChange = function contentChange(imgRefsImage, lockIndex) {
    // @ts-ignore
    imgRefsImage.current.childNodes.forEach(function (item) {
      item.style.opacity = 0;
    });
    // @ts-ignore
    imgRefsImage.current.childNodes[lockIndex].style.opacity = 1;
  };
  var _b = (0, _react.useState)(false),
    status = _b[0],
    setStatus = _b[1];
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    className: (0, _classnames["default"])('flex-default-banner', className)
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-banner-container',
    style: formatBackgroundUrl ? {
      background: "url(" + formatBackgroundUrl + ") center no-repeat ",
      backgroundSize: 'cover'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-banner-container-external'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-banner-container-children'
  }, tabShow && tabList ? (/*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bannerTab mian"
  }, /*#__PURE__*/_react["default"].createElement("ul", null, tabList && tabList.map(function (item, index) {
    var _a = item || {},
      text = _a.text,
      href = _a.href,
      chosed = _a.chosed;
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: (0, _classnames["default"])({
        on: chosed
      }),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: href
    }, text));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'bannerTab-Mobile'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'tab-text',
    onClick: function onClick() {
      setStatus(true);
    }
  }, tabList && tabList.map(function (item) {
    var _a = item || {},
      text = _a.text,
      chosed = _a.chosed;
    return /*#__PURE__*/_react["default"].createElement("span", null, chosed ? text : '');
  }), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "arrow_down-24px"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Path",
    d: "M7 9L12 15L17 9L7 9Z",
    fill: "white"
  })))), status && (/*#__PURE__*/_react["default"].createElement("section", {
    className: 'bannerTab-Mobile-root'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'bannerTab-Mobile-mask'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'bannerTab-Mobile-wrap',
    onClick: function onClick() {
      if (status) {
        setStatus(false);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("ul", null, tabList && tabList.map(function (item, index) {
    var _a = item || {},
      text = _a.text,
      href = _a.href;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: href
    }, text));
  }), /*#__PURE__*/_react["default"].createElement("li", {
    className: 'close',
    onClick: function onClick() {
      if (status) {
        setStatus(false);
      }
    }
  }, "\u53D6\u6D88")))))))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-banner-container-left-container',
    ref: insightsRef
  }, insights && insights.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      content = _a.content;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      style: index !== 0 ? {
        opacity: 0,
        transition: 'all 0.2s ease 0s'
      } : {
        opacity: 1,
        transition: 'all 0.2s ease 0s'
      },
      className: (0, _classnames["default"])('flex-default-banner-container-left', {
        'flex-default-banner-container-left-tabShow': tabShow && tabList
      })
    }, /*#__PURE__*/_react["default"].createElement("h1", null, title), /*#__PURE__*/_react["default"].createElement("p", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-default-banner-container-left-div'
    }, compatibleArr.map(function (item, index) {
      var extendProps = (item || {}).extendProps;
      return item.filedVideoList ? (/*#__PURE__*/_react["default"].createElement("a", __assign({
        className: (0, _classnames["default"])('not-a-style', {
          'flex-default-banner-container-left-div--none': item.supplement
        }),
        key: index
      }, extendProps || {}, {
        href: "javascript:void(0);",
        onClick: function onClick() {
          (0, _utils.reinitIframe)({
            filedVideoBg: item.filedVideoBg,
            filedVideoList: item.filedVideoList,
            postMessageUrl: item.postMessageUrl
          });
        }
      }), item.label)) : (/*#__PURE__*/_react["default"].createElement("a", __assign({}, extendProps || {}, {
        className: (0, _classnames["default"])('', {
          'flex-default-banner-container-left-div--none': item.supplement
        }),
        key: index,
        href: item.href
      }), item.label));
    })));
  })), formatBackgroundUrlLogo ? (0, _typeof2["default"])(formatBackgroundUrlLogo) === 'object' ? (/*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-default-bg-c-hero-icon-mod-multiple-container",
    ref: imgRefsImage
  }, formatBackgroundUrlLogo.map(function (_listItem, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: index !== 0 ? {
        opacity: 0,
        transition: 'all 0.8s ease 0s'
      } : {
        opacity: 1,
        transition: 'all 0.8s ease 0s'
      },
      key: index,
      className: "flex-default-bg-c-hero-icon-mod-multiple"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        // backgroundImage: `url(${'https://main.qcloudimg.com/qcintl-cms/154/1624606606504/754bc141e129a4637551d105c51238b5.svg'})`
      }
    }), /*#__PURE__*/_react["default"].createElement("img", {
      src: 'https://main.qcloudimg.com/qcintl-cms/154/1624607171297/2a40d8765c1b928aa5544c03aff8a32f.svg'
    }), _listItem.map(function (_item, index) {
      return /*#__PURE__*/_react["default"].createElement("img", {
        style: {},
        key: index,
        src: _listItem[index || 0]
      });
    }), /*#__PURE__*/_react["default"].createElement("img", {
      className: 'last-cover-bg',
      src: 'https://main.qcloudimg.com/qcintl-cms/154/1624607171297/2a40d8765c1b928aa5544c03aff8a32f.svg'
    }));
  }))) : (/*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-default-bg-c-hero-icon-mod",
    style: {
      backgroundImage: "url(" + formatBackgroundUrlLogo + ")"
    }
  })) : null, (0, _typeof2["default"])(formatBackgroundUrlLogo) === 'object' ? (/*#__PURE__*/_react["default"].createElement("ul", {
    ref: useRefLi,
    className: 'flex-default-banner-container__ul',
    onClick: function onClick(e) {
      if (e.target) {
        var lockIndex_1 = 0;
        var nodeTarget_1 = e.target || {};
        // @ts-ignore
        if (nodeTarget_1.nodeName === 'LI') {
          play = true;
          // @ts-ignore
          useRefLi.current.childNodes.forEach(function (item, index) {
            item.childNodes[0].style.transform = "scale(0,1)";
            if (item === nodeTarget_1) {
              lockIndex_1 = index;
            }
          });
          contentChange(imgRefsImage, lockIndex_1);
          contentChange(insightsRef, lockIndex_1);
          // @ts-ignore
          nodeTarget_1.childNodes[0].style.transform = "scale(" + 1 + ",1)";
        }
      }
      //
    }
  }, listMap.length > 1 ? listMap.map(function (_item, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("span", null));
  }) : null)) : null))));
});
FlexBanner.displayName = 'TCIFlexBanner';
var _default = exports["default"] = FlexBanner;